import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  UnauthorizedContainer,
  MessageContainer,
  ButtonContainer,
} from "../styles/LoginStyles";
import Text from "../../../components/Common/Text";
import CustomButton from "../../../components/CustomButton/CustomButton";
import Colors from "../../../themes/Colors";
import AuthActions from "../../../stores/auth/Actions";

const UnauthorizedScreen = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { requiredPermissions, isAdminBlocked } = location.state || {};
  
  const authUserData = useSelector((state) => state.auth.authUserData);
  const { prestador, isEmailUser } = authUserData || {};
  const userRoles = prestador?.roles || [];
  const hasEmailSymbol = (typeof prestador?.codigo === 'string' && prestador?.codigo?.includes("@")) || prestador?.email?.includes("@") || isEmailUser;
  const hasNoRoles = hasEmailSymbol && userRoles.length === 0;

  const getMessage = () => {
    if (hasNoRoles) {
      return "No estás autorizado para acceder a esta funcionalidad. Por favor, contacta al administrador para que se asegure de que tu usuario tenga el rol necesario para acceder.";
    }
    if (isAdminBlocked) {
      return "Esta funcionalidad no está disponible para administradores del Stand Virtual.";
    }
    if (requiredPermissions?.length > 0) {
      return `No tienes los permisos necesarios para acceder a esta página. Se requieren los siguientes permisos: ${requiredPermissions.join(
        ", "
      )}`;
    }
    return "No tienes permisos para acceder a esta página.";
  };

  const getTitle = () => {
    return "Acceso Denegado";
  };

  const handleLogout = () => {
    dispatch(AuthActions.logoutUser());
  };

  return (
    <UnauthorizedContainer>
      <MessageContainer>
        <Text
          size="28px"
          weight="600"
          margin="0 0 20px 0"
          textAlign="center"
          isTittle={true}
        >
          {getTitle()}
        </Text>

        <Text
          size="16px"
          color={Colors.txt}
          margin="0"
          textAlign="center"
          weight="400"
        >
          {getMessage()}
        </Text>
      </MessageContainer>

      <ButtonContainer>
        {hasNoRoles ? (
          <CustomButton
            label="Cerrar Sesión"
            onClick={handleLogout}
            width="200px"
            height="45px"
            fontSize="16px"
          />
        ) : (
          <CustomButton
            label="Volver al Dashboard"
            onClick={() => history.push("/dashboard")}
            width="200px"
            height="45px"
            fontSize="16px"
          />
        )}
      </ButtonContainer>
    </UnauthorizedContainer>
  );
};

export default UnauthorizedScreen;
